import React, { useState } from 'react';
// import styles from './ConfirmModal.module.scss';
import global from 'components/ui/UIGeneral.module.scss';
import { Button, Checkbox } from 'components/ui';
import ElementsBlock from 'components/ui/elementsBlock/ElementsBlock';
import t from 'utils/t';

const StatusModal = ({ onConfirm, onCancel, pageSearch, updateSearchInURL }) => {
  const filter = pageSearch.get('filter[status]')?.split(',');
  const [form, setForm] = useState({
    inactive: filter?.includes('inactive'),
    active: filter?.includes('active'),
  });

  const setFormValue = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const onConfirmLocal = () => {
    const newValue = [];
    Object.entries(form).forEach(item => {
      if (item[1]) {
        newValue.push(item[0]);
      }
    });
    pageSearch.set('filter[status]', newValue);
    updateSearchInURL();
    onConfirm();
  };

  return (
    <>
      <div className={global.modalOverlay} onClick={onCancel} />
      <div className={global.modal}>
        <div className={global.modalTitle}>Фільтр</div>
        <div className={global.modalBody}>
          <ElementsBlock className={'d-flex flex-flow-wrap mb-0 flex-column'}>
            <Checkbox
              name="active"
              label={t('active')}
              value={form.active}
              onChange={e => setFormValue(e, 'active')}
            />
            <Checkbox
              name="inactive"
              label={t('inactive')}
              value={form.inactive}
              onChange={e => setFormValue(e, 'inactive')}
            />
          </ElementsBlock>
        </div>
        <div className={global.modalActions}>
          <Button type="button" text={'Ок'} onClick={onConfirmLocal} />
        </div>
      </div>
    </>
  );
};

export default StatusModal;
